module.exports = __webpack_public_path__ + "static/media/lock-solid-orange.b6c28ad7.svg";